// extracted by mini-css-extract-plugin
export var changeIcon = "_5x-4";
export var container = "_5x-0";
export var divider = "_5x-7";
export var externalLinkIcon = "_5x-1";
export var green = "_5x-5";
export var helpCircleIcon = "_5x-3";
export var iconButton = "_5x-2";
export var red = "_5x-6";